import { cleanMessageBody, preprocessAngleBracketHyperlinks } from "./cleaning";

/**
 * Readable timeline preview: strip common signatures / reply scaffolding, truncate.
 */
export function extractTimelineSnippet(raw: string, maxChars = 300): string {
  const cleaned = cleanMessageBody(raw);
  if (!cleaned) return "";

  let s = preprocessAngleBracketHyperlinks(cleaned);

  const sepDoubleDash = /\n--\s*\n/;
  if (sepDoubleDash.test(s)) {
    s = (s.split(sepDoubleDash)[0] ?? "").trimEnd();
  }

  const repliesOnWrote = /\nOn[\s\S]{5,260}\bwrote:[\s\n]*(?:\n|$)/i;
  const onMatch = repliesOnWrote.exec(s);
  if (onMatch?.index !== undefined && onMatch.index > 48) {
    s = s.slice(0, onMatch.index).trimEnd();
  }

  const decoSep =
    /\n[^\S\n]*(?:────────────────+|────────+|____________+|━━━━━━━━+|_{10,}|={10,})\s*\n/;
  const sepHit = decoSep.exec(s);
  if (sepHit?.index !== undefined && sepHit.index >= 72) {
    s = s.slice(0, sepHit.index).trimEnd();
  }

  if (s.length <= maxChars) return s.trimEnd();

  const cut = s.slice(0, maxChars);
  const boundary = Math.max(cut.lastIndexOf(" "), cut.lastIndexOf("\n"));
  const truncateAt = boundary > maxChars * 0.45 ? boundary : maxChars;
  return `${s.slice(0, truncateAt).trimEnd()}…`;
}
